import { OnlineMassMessagesService } from '@api'
import { attach, createEffect } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { processDataForMessageStatistics } from '@/modules/online-mass-messages/utils.ts'
import { handleError } from '@/utils/error'

export const getMassMessageStatisticsByMessageIdFx = attach({
  name: 'summarize chat',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (messageId: number, { creatorId }) => ({
    creatorId: creatorId!,
    messageId,
  }),
  effect: createEffect(
    async ({
      creatorId,
      messageId,
    }: {
      creatorId: number
      messageId: number
    }) => {
      const data = await OnlineMassMessagesService.getBulkMessageStatisticsV2({
        creatorId,
        messageId,
      })

      return processDataForMessageStatistics(data, 'Priority Mass Messages')
    },
  ),
})

getMassMessageStatisticsByMessageIdFx.failData.watch((error) => {
  handleError(error, 'Failed to get mass message statistics by message id')
})
